import requests from "./httpService";

const DropdownServices = { 
  getDepartmentDropdown: async (body) => {
    return requests.post("/department/drop-down", body);
  }, 
  getEmployeeDropdown: async () => {
    return requests.post("/employee/dropdown");
  },
  getProjectDropdown: async () => {
    return requests.post("/project/drop-down");
  },   
  getClientDropdown: async () => {
    return requests.post("/client/drop-down");
  },  
}; 

export default DropdownServices; 
